export default __webpack_public_path__ + "static/media/Paraimg3.be185d7a.jpg";